import { BasicProps } from '@eastcoal/common/types/component'

import { ExternalLink } from './ExternalLink'
import { HelpLink } from './HelpLink'
import { Introduction } from './Introduction'
import { RightInformation } from './RightInformation'

export const LayoutFooter = (props: BasicProps) => {
  return (
    <footer {...props}>
      <Introduction />
      <HelpLink />
      <ExternalLink />
      <RightInformation />
    </footer>
  )
}
